import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'
import { printCSS } from '@utils/style'

interface TagProps {
  text: string
}

const Wrapper = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_75 },
      },
    },
  }) => css`
    border: 1px solid ${grey_75};
    border-radius: 6px;
    width: fit-content;
    max-width: 300px;
    display: flex;
    align-items: center;
  `}
`

const StyledText = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_75 },
      },
      fonts: { goodOT },
    },
  }) => css`
    font-family: ${goodOT};
    font-style: normal;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    padding: 6px 16px 4px;
    color: ${grey_75};
    word-break: break-all;
    text-align: center;
    ${mobileCSS(css`
      padding: 5px 16px 4px;
      font-size: 15px;
      line-height: 17px;
    `)}
    ${printCSS(css`
      font-size: 12px;
      line-height: 14px;
      padding: 2px 8px;
    `)}
  `}
`

const Tag: FunctionComponent<TagProps> = ({ text }) => {
  return (
    <>
      {text && (
        <Wrapper>
          <StyledText>{text}</StyledText>
        </Wrapper>
      )}
    </>
  )
}

export default Tag
